import appointmentTypePresetVisibilityApi from './api/appointmentTypePresetVisibilityApi';

/** @type {string[]} */
export const DEFAULT_HIDDEN_PRESET_KEYS = [];

/**
 * GET /api/organization/appointment-type-preset-visibility
 * PUT /api/organization/appointment-type-preset-visibility — practice admins only
 */
export { default as appointmentTypePresetVisibilityApi } from './api/appointmentTypePresetVisibilityApi';

export function normalizeHiddenPresetKeys(value) {
  if (!Array.isArray(value)) return [];
  return value.filter((key) => typeof key === 'string' && key.length > 0);
}

export function isPresetHidden(hiddenPresetKeys, slug) {
  return normalizeHiddenPresetKeys(hiddenPresetKeys).includes(slug);
}

/**
 * Safe loader for react-query: never throws; missing endpoint or errors mean nothing hidden.
 * @returns {Promise<string[]>}
 */
export async function fetchPresetVisibility() {
  try {
    const data = await appointmentTypePresetVisibilityApi.get();
    return normalizeHiddenPresetKeys(data?.hiddenPresetKeys);
  } catch {
    return DEFAULT_HIDDEN_PRESET_KEYS;
  }
}
